import React, { useMemo, useState } from "react";
import "../../../css/View/SummaryCars.css";

const SummaryCars = ({ registrations, waitlistRegistrations = [] }) => {
  const [includeWaitlistCars, setIncludeWaitlistCars] = useState(false);
  const [mode, setMode] = useState("confirmed"); 

  const activePeople = useMemo(() => {
    return (registrations || []).flatMap((r) => {
      const activeParticipants = (r.participants || []).filter(
        (p) => p.status !== 4 && p.status !== 5
      );
      const primary = activeParticipants.find((p) => p.isPrimary);
      if (!primary) return [];

      return [
        {
          ...primary,
          reservationCode: r.reservationCode,
          departureCity: r.additionalInfo?.departureCity,
          departureCityInfo: r.additionalInfo?.departureCityInfo,
          hasCar: r.additionalInfo?.hasCar,
          passengerCount: r.additionalInfo?.canTakePassengers
            ? r.additionalInfo.passengerCount
            : null,
          carComment: r.userComment,
          participantCount: !r.createdAt ? (r.pax || 0) : activeParticipants.length,
          reservationStatus: r.status,
        },
      ];
    });
  }, [registrations]);

  const waitlistPeople = useMemo(() => {
    return (waitlistRegistrations || []).flatMap((r) => {
      const activeParticipants = (r.participants || []).filter(
        (p) => p.status !== 4 && p.status !== 5
      );
      const primary = activeParticipants.find((p) => p.isPrimary);
      if (!primary) return [];

      return [
        {
          ...primary,
          reservationCode: r.reservationCode,
          departureCity: r.additionalInfo?.departureCity,
          departureCityInfo: r.additionalInfo?.departureCityInfo,
          hasCar: r.additionalInfo?.hasCar,
          passengerCount: r.additionalInfo?.canTakePassengers
            ? r.additionalInfo.passengerCount
            : null,
          carComment: r.userComment,
          participantCount: !r.createdAt ? (r.pax || 0) : activeParticipants.length,
          reservationStatus: r.status,
        },
      ];
    });
  }, [waitlistRegistrations]);

  const activeWithCar = useMemo(
    () => activePeople.filter((p) => p.hasCar === true),
    [activePeople]
  );
  const activeWithoutCar = useMemo(
    () => activePeople.filter((p) => !p.hasCar),
    [activePeople]
  );

  const waitlistWithCar = useMemo(
    () => waitlistPeople.filter((p) => p.hasCar === true),
    [waitlistPeople]
  );

const withCar = useMemo(() => {
  return mode === "confirmed" ? activeWithCar : waitlistWithCar;
}, [mode, activeWithCar, waitlistWithCar]);


  const renderTable = (data, showPassengerCount) => (
    <div className="table-scroll-container">
      <table className="summary-car-table">
        <thead>
          <tr>
            <th>Rezerwacja</th>
            <th>Miasto</th>
            {showPassengerCount && <th>Wolne miejsca</th>}
            <th>Komentarz</th>
          </tr>
        </thead>
        <tbody>
          {data.map((p, idx) => (
            <tr key={idx}>
              <td>
                <div>
                  <span className={`reg-code status-${p.reservationStatus}`}>
                    {p.reservationCode}
                  </span>{" "}
                  <span className="reservation-count">
                    ({p.participantCount} x <i className="fas fa-user"></i>)
                  </span>
                </div>
                <div className="participant-name">{p.preferredName}</div>
              </td>

              <td>{p.departureCity || "-"}</td>
              {showPassengerCount && <td>{p.passengerCount ?? "-"}</td>}
              <td>{p.carComment || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="summary-cars-container">
    <div className="summary-cars-header summary-cars-header--with-controls">
      <h3>Transport samochodem</h3>

<div className="summary-cars-togglebar">
  <div
    className={`summary-cars-toggle ${mode === "confirmed" ? "is-active" : ""}`}
    role="button"
    tabIndex={0}
    onClick={() => setMode("confirmed")}
    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setMode("confirmed")}
  >
    Potwierdzone
  </div>

  <div
    className={`summary-cars-toggle ${mode === "waitlist" ? "is-active" : ""}`}
    role="button"
    tabIndex={0}
    onClick={() => setMode("waitlist")}
    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setMode("waitlist")}
  >
    Lista rezerwowa
  </div>
</div>

    </div>



      {renderTable(withCar, true)}
      <div className="summary-cars-header">
        <h3>Bez transportu samochodem</h3>
      </div>
      {renderTable(activeWithoutCar, false)}

    </div>
  );
};

export default SummaryCars;
